export class Site {
    abbreviation = '';
    blog_id = 0;
    date = '';
    desiredSlug = '';
    domain = '';
    categories = [];
    gmt_date = '';
    meta = {
        facebookDescription: '',
        facebookImage: '',
        facebookTitle: '',
        hideOnFront: false,
        hideOnCategory: false,
        hideOnTag: false,
        hideOnAuthor: false,
        hideOnDate: false,
        hideOnSearch: false,
        hideOnFeed: false,
        hideOnGoogle: false,
        socialImage: {}
    };
    name = '';
    nextPostLink = '';
    permalink = '';
    post_id = 0;
    primary = false;
    samplePermalink = '';
    slug = '';
    status = '';
    newStatus = '';


    constructor(site: object) {
        for(var prop in site) {
            if( this.hasOwnProperty(prop) ) {
                this[prop] = site[prop];
            }
        }
    }
}